import { AuthenticationState } from './reducer';

export const getAuthentication = (state: AuthenticationState) => state.authentication;

export const getIsLoggedIn = (state: AuthenticationState) => state.isLoggedIn;


